import mongoose from "mongoose";

export enum RefreshQueueItemStatus {
  PENDING = 0,
  IN_PROGRESS = 1,
  SUCCEEDED = 2,
  FAILED = -1,
  CANCELLED = -2,
}

export interface RefreshQueueItem {
  _id: mongoose.Schema.Types.ObjectId;
  userId: string; // initiator
  userEmail: string; // initiator
  refresher: string;
  refreshId: string;
  accountId: string;
  accountCategory: string;
  baseAccountId: string;
  baseAccountCategory: string;
  isBaseAccount: boolean;
  chaining: boolean;
  offset: number;
  percentComplete: number;
  currentStatus: RefreshQueueItemStatus;
  statusHistory: {
    code: RefreshQueueItemStatus;
    time: Date;
  }[];
  createdAt: Date;
  statusAt?: Date;
  completedAt?: Date;
  error?: string;
}

export const RefreshQueueItemSchema = new mongoose.Schema<RefreshQueueItem>({
  userId: String,
  userEmail: String,
  refresher: String,
  refreshId: { type: String, default: "" },
  accountId: String,
  accountCategory: String,
  baseAccountId: String,
  baseAccountCategory: String,
  isBaseAccount: Boolean,
  chaining: { type: Boolean, default: false },
  offset: { type: Number, default: 0 },
  percentComplete: { type: Number, default: 0 },
  currentStatus: Number,
  statusHistory: [{
    _id: false,
    code: Number,
    time: Date,
  }],
  createdAt: { type: Date, default: () => Date.now() },
  statusAt: Date,
  completedAt: Date,
  error: String,
});

const props: (keyof RefreshQueueItem)[] = [
  "userId",
  "userEmail",
  "refresher",
  "refreshId",
  "accountId",
  "accountCategory",
  "baseAccountId",
  "baseAccountCategory",
  "offset",
  "percentComplete",
  "currentStatus",
  "createdAt",
  "statusAt",
  "completedAt",
  "error",
];

const searchProps: (keyof RefreshQueueItem)[] = [
  "refreshId",
];

const filterProps: (keyof RefreshQueueItem)[] = [
  "userId",
  "refresher",
  "currentStatus",
  "accountId",
];

const dateProps: (keyof RefreshQueueItem)[] = [
  "createdAt",
  "statusAt",
  "completedAt",
];


export const refreshQueueItemUtils = {
  props,
  searchProps,
  filterProps,
  dateProps,
};
